<template>
  <main>
    <div class="container-fluid mt-3" style="width: 100%; max-width: 1200px" v-if="!loading && clubeDesconto">
      <div class="row mb-3 g-3 mt-3">
        <div class="col-12">
          <div class="container">
            <div class="row">
              <div id="page-offer" class="col-lg-12">
                <div class="row border-bottom-gray mb-5 pb-5">
                  <div class="col-md-12">
                    <div class="text-center">
                      <img :src="clubeDesconto.offer.urlImage" class="img-fluid rounded"
                        style="max-height: 220px; max-width: 220px" />
                    </div>
                    <div class="a-divider a-divider-break"></div>
                    <div class="px-md-5">
                      <div style="padding-bottom: 16px">
                        <h5 class="primary-color"><strong>Benefício</strong></h5>
                        <p>{{ clubeDesconto.offer.benefitsText }}</p>
                        <p>{{ clubeDesconto.offer.description }}</p>
                      </div>

                      <div class="offer-about plataform-target" style="padding-bottom: 20px"
                        v-if="clubeDesconto.typeAction === 'ACCESS_OFFER'">
                        <b>
                          <h5 class="primary-color"><strong> Mecânica de resgate</strong></h5>
                        </b>
                        <div v-html="clubeDesconto.offer.rescueMechanics"></div>
                      </div>

                      <div class="offer-legal plataform-target" style="padding-bottom: 38px"
                        v-if="clubeDesconto.typeAction === 'ACCESS_OFFER'">
                        <b>
                          <h5 class="primary-color"> <strong>Condições do benefício</strong> </h5>
                        </b>
                        <div v-html="clubeDesconto.offer.benefitsConditions"></div>
                      </div>

                      <div class="d-flex justify-content-center mt-5"
                        v-if="clubeDesconto.typeAction === 'ACCESS_OFFER' && clubeDesconto.offer.coupon">
                        <div class="border border-info rounded">
                          <div class="coupon-body">
                            <span>Utilize o cupom</span>
                            <br />
                            <span class="coupon">{{ clubeDesconto.offer.coupon }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="row m-3" v-if="erro">
                        <div class="col card my-2 badge-danger text-center p-3 text-uppercase mt-3">
                          {{ erro }}
                        </div>
                      </div>
                      <div class="d-flex justify-content-center mt-3" v-if="clubeDesconto.actionSettings.pathParams.url">
                        <button class="btn btn-lg primary-background-color"
                          @click="openBeneficio(clubeDesconto.actionSettings.pathParams.url)">
                          {{ clubeDesconto.actionSettings.labelButton }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Loading v-if="loading"></Loading>
  </main>
</template>

<script>
import Loading from "@/components/Loading.vue";
import { getOffersById } from "../service/clube/serviceClubeAPI";


export default {
  name: "DetalhesClubeDesconto",
  components: { Loading },
  data() {
    return {
      erro: "",
      loading: true
    };
  },
  created() {
    const offerId = this.$route.params.offerId;
    this.getOffer(offerId);
  },

  methods: {
    getOffer(offerId) {
      this.loading = true;
      getOffersById(offerId).then(offer => {
        this.clubeDesconto = offer.data;
        if (offer.code !== "200") {
          this.erro = `${offer.code} - ${offer.message}`
        }
        this.loading = false;
      }).catch(error => {
        this.erro = `500- ${error.data}`
        this.loading = false;
      })
    }
  },
};
</script>
<style scoped lang="scss">
.border {
  min-width: 150px;
  min-height: 80px;
}

.coupon-body {
  margin: 15px;
  text-align: center;
}

.coupon {
  font-weight: bold;
  font-size: 24px;
}

.btn {
  min-width: 50%;
  margin: 10px;
  font-size: 24px;
}

.a-divider.a-divider-break {
  text-align: center;
  position: relative;
  top: 2px;
  padding-top: 1px;
  margin-bottom: 14px;
  line-height: 0;

  &:after {
    content: "";
    width: 100%;
    background-color: transparent;
    display: block;
    height: 1px;
    border-top: 1px solid var(--cor-principal);
    position: absolute;
    top: 50%;
    margin-top: -1px;
    z-index: 1;
  }

  h5 {
    line-height: 1;
    font-size: 12px;
    color: #767676;
    font-weight: 400;
    z-index: 2;
    position: relative;
    display: inline-block;
    background-color: #fff;
    padding: 0 8px 0 7px;
  }
}
</style>
